import { render, staticRenderFns } from "./ReleaseTypeLabel.vue?vue&type=template&id=25d8bc6a&scoped=true&"
import script from "./ReleaseTypeLabel.vue?vue&type=script&lang=js&"
export * from "./ReleaseTypeLabel.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseTypeLabel.vue?vue&type=style&index=0&id=25d8bc6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d8bc6a",
  null
  
)

export default component.exports